'use strict';
/*
  clean — premium editorial captions. Sharp DIN-condensed type, the key word in
  a rounded accent chip, a whisper-subtle reactive EQ baseline, soft film grade.
  Looks intentional on a solid bg (music) and crisp over footage (talk/photos).
*/
const { layoutCue } = require('./_common');
const { roundRect, FONTS } = require('../lib/draw');

const palette = { bg: '#0b0b0d', fg: '#ffffff', accent: '#ffe14d', accent2: '#19d27c', ink: '#101014' };

function init(st){ st.s.font = st.tk.registerFamily('ForgeDIN', FONTS.dinCond) || undefined; st.s.hue = 0; st.s.pop = 0; }
function onBeat(st, power){ st.s.pop = Math.min(1, st.s.pop + power * 0.5); }

function background(ctx, st){
  const { W, H } = st; st.s.pop *= 0.85; st.s.hue += 0.05;
  if (!st.overlayMode) {
    const g = ctx.createLinearGradient(0, 0, 0, H);
    g.addColorStop(0, '#0a0a0c'); g.addColorStop(1, '#15131a');
    ctx.fillStyle = g; ctx.fillRect(0, 0, W, H);
    // soft drifting accent glow reacting to mids
    const e = st.m / 255, gx = st.CX + Math.sin(st.NOW / 4000) * W * 0.2, gy = H * 0.4 + Math.cos(st.NOW / 5200) * H * 0.12;
    const rad = ctx.createRadialGradient(gx, gy, 40, gx, gy, W * (0.55 + e * 0.25));
    rad.addColorStop(0, `rgba(255,225,77,${0.05 + e * 0.06})`); rad.addColorStop(1, 'rgba(0,0,0,0)');
    ctx.fillStyle = rad; ctx.fillRect(0, 0, W, H);
  } else {
    const g = ctx.createLinearGradient(0, H * 0.52, 0, H);
    g.addColorStop(0, 'rgba(0,0,0,0)'); g.addColorStop(1, 'rgba(0,0,0,0.5)');
    ctx.fillStyle = g; ctx.fillRect(0, H * 0.52, W, H * 0.48);
  }
  // subtle reactive EQ baseline (music only — off for talk/subtitle focus)
  if (st.spectrum && st.reactive) {
    const { NB, data } = st.spectrum, f = st.f, by = st.overlayMode ? H * 0.9 : H * 0.88, bw = W / NB;
    ctx.save(); ctx.globalAlpha = st.overlayMode ? 0.28 : 0.4;
    for (let i = 0; i < NB; i++) {
      const v = (data[f * NB + i] || 0) / 255, bh = (4 + v * 46);
      ctx.fillStyle = i % 6 === 0 ? palette.accent : 'rgba(255,255,255,0.9)';
      ctx.fillRect(i * bw + bw * 0.2, by - bh / 2, bw * 0.6, bh);
    }
    ctx.restore();
  }
}

function paintToken(ctx, o){
  const { T, cx, cy, px, scl, alpha, emph, st, ghost } = o, tk = st.tk;
  const pop = emph ? 1 + st.s.pop * 0.05 : 1;
  ctx.save(); ctx.globalAlpha = alpha; ctx.translate(cx, cy); ctx.scale(scl * pop, scl * pop);
  ctx.font = tk.font(px, 900, st.s.font); ctx.textAlign = 'center'; ctx.textBaseline = 'middle';
  if (emph && !ghost) {
    ctx.fillStyle = palette.accent;
    tk.chip(ctx, T, px, 0.18, 0.16); ctx.fill();
    ctx.fillStyle = palette.ink; ctx.fillText(T, 0, 0);
  } else {
    ctx.shadowColor = 'rgba(0,0,0,0.55)'; ctx.shadowBlur = px * 0.12; ctx.shadowOffsetY = px * 0.03;
    ctx.lineJoin = 'round'; ctx.lineWidth = px * 0.14; ctx.strokeStyle = 'rgba(0,0,0,0.8)'; ctx.strokeText(T, 0, 0);
    ctx.shadowColor = 'transparent';
    ctx.fillStyle = emph ? palette.accent : palette.fg; ctx.fillText(T, 0, 0);
  }
  ctx.restore();
}

function drawCue(ctx, st){
  const anchor = st.mode === 'talk' ? 0.74 : 0.66;
  layoutCue(ctx, st, { sizes: { big: 132, mid: 108, small: 66 }, anchor, safeW: 0.86, reveal: 0.2, stagger: 0.05, trail: 2, trans: 0.2, family: st.s.font, paintToken });
}

function overlay(ctx, st){
  const tk = st.tk;
  // soft film grade: faint grain + gentle vignette (translucent → safe over footage)
  ctx.save(); ctx.globalAlpha = 0.035; ctx.globalCompositeOperation = 'overlay'; ctx.drawImage(tk.grain(), -Math.random()*100, -Math.random()*100); ctx.restore();
  ctx.drawImage(tk.vignette(st.overlayMode ? 0.45 : 0.6, 360), 0, 0);
  if (!st.overlayMode) {
    ctx.fillStyle = 'rgba(255,255,255,0.9)'; ctx.fillRect(0, st.H - 6, st.W * st.progress, 6);
    ctx.fillStyle = palette.accent; ctx.fillRect(0, st.H - 6, st.W * st.progress, 2);
  }
}

module.exports = { id: 'clean', label: 'Clean · bold captions', palette, init, background, drawCue, overlay, onBeat, paintToken };
